import { motion } from "framer-motion";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import moment from "moment";
import { Item } from "../NestedPayerResponse";

const PreauthorizationEncounterNested = () => {
  const { viewPreauthorizationInfo } = useSelector(
    (state) => state.preauthorization
  );

  const encounter = viewPreauthorizationInfo?.provider_request?.encounter;

  const itemDetails = [
    {
      id: 1,
      title: "Triage Category",
      value: encounter?.enct_trgctgname,
    },
    {
      id: 1,
      title: "Emergency Arrival Code",
      value: encounter?.enct_emrgarvlcode,
    },
    {
      id: 1,
      title: "Emergency Department Disposition",
      value: encounter?.enct_emrgdeptdispcode,
    },
    {
      id: 1,
      title: "Emergency Service Date",
      value: "",
    },
    {
      id: 1,
      title: "Cause Of Death",
      value: "",
    },
    {
      id: 3,
      title: "Encounter Class",
      value: encounter?.enct_clsname,
    },
    {
      id: 4,
      title: "Encounter Status",
      value: encounter?.enct_status,
    },
    {
      id: 5,
      title: "Service Event Type",
      value: encounter?.enct_sevnttypname,
    },
    {
      id: 5,
      title: "Act Priorty",
      value: "Elective",
    },
    {
      id: 9,
      title: "Admission Specilaity",
      value: encounter?.enct_admnspecltyname,
    },

    {
      id: 9,
      title: "Intend Length of stay",
      value: encounter?.enct_intdlghstyname,
    },

    {
      id: 5,
      title: "Discharge Speciality",
      value: encounter?.enct_discgspecltyname,
    },
    {
      id: 5,
      title: "Admit Source",
      value: encounter?.enct_admsrcename,
    },
    {
      id: 5,
      title: "Empolyment Impacted Period",
      value: "",
      //   value: empolyImapct?.timingPeriod
      //     ? `From ${empolyImapct?.timingPeriod?.start} To ${empolyImapct?.timingPeriod?.end}`
      //     : null,
    },
  ];

  return (
    <motion.div
      className="rounded p-3 position-relative mt-3 mb-3"
      style={{ border: "2px solid #d9f8eb" }}
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
      transition={{ duration: 0.5 }}
    >
      {/* Floating Badge Header */}
      <div className="position-absolute top-0 start-40 translate-middle-y px-2 d-none d-md-block">
        <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
          <span className="fs-11">Encounter</span>
        </span>
      </div>

      {/* Dates Section */}
      <Row className="mt-3">
        {encounter?.enct_stdate && (
          <Col xs={12} md={4}>
            <div className="d-flex gap-3">
              <span className="fw-bold fs-10">Admission Date</span>
              <span className="fw-normal text-600 fs-10">
                {moment(encounter?.enct_stdate).format(
                  "DD-MM-YYYY , hh:mm:ss A"
                )}
              </span>
            </div>
          </Col>
        )}
        {encounter?.enct_eddate && (
          <Col xs={12} md={4}>
            <div className="d-flex gap-3">
              <span className="fw-bold fs-10">Discharge Date</span>
              <span className="fw-normal text-600 fs-10">
                {moment(encounter?.enct_eddate).format(
                  "DD-MM-YYYY , hh:mm:ss A"
                )}
              </span>
            </div>
          </Col>
        )}
        {encounter?.enct_trgdte && (
          <Col xs={12} md={4}>
            <div className="d-flex gap-3">
              <span className="fw-bold fs-10">Triage Date</span>
              <span className="fw-normal text-400 fs-10">
                {encounter?.enct_trgdte
                  ? moment(encounter?.enct_trgdte).format(
                      "DD-MM-YYYY , hh:mm:ss A"
                    )
                  : ""}
              </span>
            </div>
          </Col>
        )}
      </Row>

      <hr />

      {/* Dynamic Info Section */}
      <Row>
        {itemDetails
          .filter((item) => item.value)
          .map((item) => (
            <Col key={item.id} xs={12} md={4} xl={3} className="mb-3">
              <Item title={item.title} value={item.value} />
            </Col>
          ))}
      </Row>
    </motion.div>
  );
};

export default PreauthorizationEncounterNested;
